import {Select, FormGroup, Paper, TextField, Typography, FormControl, InputLabel, Button, MenuItem, FormControlLabel, Checkbox, Switch}  from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";
import { fetchEmployees, addTask, fetchDest, gmailSend, fetchtaskbytripid, fetchSuppliers, fetchTripbyId} from "../api/customerapi";
import moment from "moment";
import {total, pending, supplierpending, sptotal, identifydest} from "./date.js"



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const CreateTask = () => {

    const classes = useStyles();
    var { cuser, role } = GetRole();
    //const dispatch=useDispatch();
    const [taskData, settaskData] =useState({
        task_status:"Open",
        task_description:"",
        task_category:"",
        task_priority:"",
        ticket_category:"",
    });
    // const [tData, settData]=useState(null);
    const [supplierData, setsupplierData]=useState([])
    const [emp, setemp]=useState([])
    const [emplist, setemplist]=useState([])
    const [dest, setdest]=useState([])
    var fupsomeDate = new Date();
  
    fupsomeDate.setDate(fupsomeDate.getDate()); 
  const fupy=fupsomeDate.getFullYear()
  const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
  const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
  const fupfinalDate=(fupy+"-"+fupm+"-"+fupdt)

    const getEmployees = async () => {
        try{
        var data = await fetchEmployees();
        setemplist(data.data)
        const empsplist = data.data.filter((emp) => !(emp.role == "Ex-employee" || emp.role == "Sales"  || emp.role == "Marketing" || emp.role == "Sales Support"));
        //const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
        var empshortname = empsplist.map((emp) => emp.short_name);
        if(empshortname.length==0){
          empshortname=["Amit"]
        }
        setemp(empshortname);
    }catch(err){
        console.log(err)
      }
      };
 
      const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      }

      const getSuppliers=async()=>{
        const data=await fetchSuppliers()
        const airportlist2=data.data.sort((a, b) => (a.supplier_name> b.supplier_name) ? 1: -1);
        setsupplierData(airportlist2.filter(s=>s.supplier_type=="DMC" || s.supplier_type=="Hotel Portal" || s.supplier_type=="Hotel"))
      }

    useEffect(() => {
        getEmployees()
        getDest()
        getSuppliers()
    }, [])

    const getrecepient = (person) => { 
      const temp=emplist.filter(data=>data.short_name==person)
      const role=temp[0].role
      if(role=="Sales"  || role=="SME" ){
        return [temp[0].email, "abhishek.sharma@jetovacations.com", "rohit.saini@jetovacations.com"]
      }else if(role=="Operations"){
        return [temp[0].email, "operations@jetovacations.com", "ops3@jetovacations.com"]
      }else if(role=="Product"){
        return [temp[0].email, "product1@jetovacations.com"]
      }else{
        return [temp[0].email]
      }
    }

    const calculateDeadline=(createdAt, category)=>{
  const created = moment(createdAt);
  const hour = created.hour();

  let deadline;
    if(category=="A"){
  if (hour >= 11 && hour < 20) {
    // Between 11:00 - 20:00
    deadline = created.add(4, "hours");
  } else if (hour >= 20) {
    // After 20:00 → next day 14:00
    deadline = created.add(1, "day").hour(14).minute(0).second(0);
  } else {
    // Before 11:00 → same day 14:00
    deadline = created.hour(14).minute(0).second(0);
  }
}
   if(category=="B"){
    deadline = created.add(48, "hours");
   }

  return {
    deadlineDate: deadline.format("YYYY-MM-DD"), // e.g. "2025-09-21"
    deadlineTime: deadline.format("HH:mm")       // e.g. "14:00"
  };
}

  
    
    //console.log(custdatalistfromdb);
    //const updatedName= useSelector((state)=> currentID ? (state.reducerNames.find((p) => p._id ===currentID)) : null);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        var flag=1
        var x=1
        if(taskData.task_priority=="P1"){
          x=window.confirm("Sure it's a P1 task?")
        }
        if(x){
        var finaltaskData={...taskData, assigned_by:cuser, createdAt:new Date()}
        if(taskData.task_category=="Book Hotel Online"){
            var obj=calculateDeadline(new Date(), "A")
            finaltaskData={...taskData, deadline_date:obj.deadlineDate, deadline_time:obj.deadlineTime}
            if(!("task_subcat" in taskData && taskData.task_subcat) || !("trip_id" in taskData && taskData.trip_id)){
              alert("Please mark if its refundable and enter trip id")
              return
            }else{
              const data=await fetchTripbyId(taskData.trip_id)
              console.log(data.data)
              var t=identifydest(data.data.primary_destination)
              if(taskData.task_subcat=="Non-Refundable"){
                var receivedtillnow=total(data.data.cust_payments)-pending(data.data.cust_payments)
                var paidtillnow=sptotal(data.data.supplier_payments)-supplierpending(data.data.supplier_payments)
                if(receivedtillnow-paidtillnow<taskData.amount){
                  alert("Insufficient money received for non-refundable booking")
                  return
                }
              
                if("file" in data.data && data.data.file.length>0){
                const pancount=data.data.file.filter(f=>f.type_of_doc=="PAN")
                const passportcount=data.data.file.filter(f=>f.type_of_doc=="Passport")
                const aadhaarcount=data.data.file.filter(f=>f.type_of_doc=="Aadhaar")
                if(t){
                if(pancount.length>0 && passportcount.length>0){

                }else{
                  alert("Atleast 1 PAN and passport required")
                  return
                }
              }else{
                   if(aadhaarcount.length>0 || passportcount.length>0){

                }else{
                  alert("Atleast 1 Aadhaar or passport required")
                  return
                }
                }
                }else{
                  alert("No document found. Cannot create ticket")
                  return
                }
              }else{
                if("file" in data.data && data.data.file.length>0){
                
                const passportcount=data.data.file.filter(f=>f.type_of_doc=="Passport")
                const aadhaarcount=data.data.file.filter(f=>f.type_of_doc=="Aadhaar")
                console.log(passportcount, aadhaarcount)
                if(t){
                if( passportcount.length>0){

                }else{
                  alert("Atleast 1 passport required")
                  return
                }
              }else{
                   if(aadhaarcount.length>0 || passportcount.length>0){

                }else{
                  alert("Atleast 1 Aadhaar or passport required")
                  return
                }
                }
                }else{
                  alert("No document found. Cannot create ticket")
                  return
                }
              }
            }
        }
        if(taskData.task_category=="Book Hotel Offline"){
             var obj=calculateDeadline(new Date(), "B")
             finaltaskData={...taskData, deadline_date:obj.deadlineDate, deadline_time:obj.deadlineTime}
             if(!("task_subcat" in taskData && taskData.task_subcat) || !("trip_id" in taskData && taskData.trip_id)){
              alert("Please mark if its refundable and enter trip id")
              return
            }
            const data=await fetchTripbyId(taskData.trip_id)
            var t=identifydest(data.data.primary_destination)
             if("file" in data.data && data.data.file.length>0){
                //const pancount=data.data.file.filter(f=>f.type_of_doc=="PAN")
                const passportcount=data.data.file.filter(f=>f.type_of_doc=="Passport")
                 const aadhaarcount=data.data.file.filter(f=>f.type_of_doc=="Aadhaar")
                 if(t){
                if(passportcount.length>0){

                }else{
                  alert("Atleast 1 PAN and passport required")
                  return
                }
              }else{
                if(aadhaarcount.length>0 || passportcount.length>0){

                }else{
                  alert("Atleast 1 Aadhaar or passport required")
                  return
                }
              }
              }
        }
        const data=await fetchtaskbytripid(taskData.trip_id)
        console.log(data.data)
        if(data.data.length>0){
          var x=window.confirm("Task already created for this trip id having task id: "+data.data[0].task_id+". Do you want to crearte another one?")
          flag=x
        }
        
        if(flag){
          console.log(finaltaskData)
        const addtaskResponse= await addTask(finaltaskData);
       
        if(addtaskResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("New task added with task id "+addtaskResponse.data.task_id);
            var from="care@jetovacations.com"
            var subject="New task assigned to you with task id "+addtaskResponse.data.task_id
            //var subject="New task assigned to you with task id "
            var body="Ticket assigned with deadline "+("task_category" in taskData?taskData.task_category:"")+" || "+("deadline_date" in taskData?taskData.deadline_date:"")+" at "+("deadline_time" in taskData?taskData.deadline_time:"")
            var to=getrecepient(taskData.assigned_to)
            console.log(from, to, subject, body)
            let receiptmail= await gmailSend(from, to, subject, body)
            alert(receiptmail.data)
            window.location = ("/taskdataentry/"+addtaskResponse.data.task_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        
        }
        }
        }else{
          alert("Change priority to P2 or P3")
        }
    }catch(err){
        console.log(err)
      } 
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Ticket</Typography>
             <FormControlLabel control={<Switch checked={"private_task" in taskData?taskData.private_task:false} color="secondary" onChange={(e)=>settaskData({...taskData, private_task:e.target.checked})}/>}  label="Private Task?" />
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Description"   InputLabelProps={{ shrink: true }} value={taskData.task_description} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> settaskData({...taskData, task_description: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="task owner">Assign To:</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Ticket Owner" required value={taskData.assigned_to} onChange={(e)=> settaskData({...taskData, assigned_to: e.target.value})}>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}    
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Trip Id"  
              
                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, trip_id: e.target.value.trim()})}/>
                <TextField variant="standard"  type="date" label="Deadline Date"   inputProps={{ min: fupfinalDate }} 
              
                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, deadline_date: e.target.value})}/>
                <TextField variant="standard"  type="time" label="Deadline Time"   
                
                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, deadline_time: e.target.value})} />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
           
                <TextField variant="standard"  label="Assigned By"   disabled value={cuser}
                className={classes.textField} InputLabelProps={{ shrink: true }} />
                 <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="priority">Priority</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="priority"  required value={taskData.task_priority} onChange={(e)=> settaskData({...taskData, task_priority: e.target.value})}>
                <MenuItem value={"P1"}>P1</MenuItem>;
                <MenuItem value={"P2"}>P2</MenuItem>;
                <MenuItem value={"P3"}>P3</MenuItem>;
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="status" required value={taskData.task_status} onChange={(e)=> settaskData({...taskData, task_status: e.target.value})}>
                <MenuItem value={"Open"}>Open</MenuItem>;
                <MenuItem value={"Close"}>Close</MenuItem>;
                <MenuItem value={"Waiting"}>Waiting</MenuItem>;
                </Select>
                </FormControl>
            </FormGroup>
           
            <FormGroup row className={classes.formgroup}>
             
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="category">Category</InputLabel>
                <Select displayEmpty 
                className={classes.textField} labelId="category" value={taskData.task_category} onChange={(e)=> settaskData({...taskData, task_category: e.target.value})}>
                <MenuItem value={"Rate Query"}>Rate Query</MenuItem>;
                <MenuItem value={"Data updation request"}>Data updation request</MenuItem>;
                <MenuItem value={"Information Query"}>Information Query</MenuItem>;
                <MenuItem value={"Asking for documents"}>Asking for documents</MenuItem>;
                <MenuItem value={"Customer Support"}>Customer Support</MenuItem>;
                <MenuItem value={"Rate Increase"}>Rate Increase</MenuItem>;
                <MenuItem value={"Package not final"}>Package not final</MenuItem>;
                <MenuItem value={"Customer asked for changes"}>Customer asked for changes</MenuItem>;
                <MenuItem value={"Book Hotel Online"}>Book Hotel Online</MenuItem>;
                <MenuItem value={"Book Hotel Offline"}>Book Hotel Offline</MenuItem>;
                <MenuItem disabled value={"Hold Ops"}>Hold Ops</MenuItem>;
                <MenuItem value={"Refund"}>Refund</MenuItem>;
                <MenuItem value={"Others"}>Others</MenuItem>;
                </Select>
                </FormControl>
           
                {taskData && taskData.task_category=="Rate Query"?(
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select  displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={taskData.task_destination} onChange={(e)=> settaskData({...taskData, task_destination: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Bali"}>Bali</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}           
                </Select>
                </FormControl>
                ):("")}
                {taskData && (taskData.task_category=="Book Hotel Online" || taskData.task_category=="Book Hotel Offline")?(
                  <div>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="subcat">Sub Category</InputLabel>
                <Select  displayEmpty required className={classes.textField} InputLabelProps={{ shrink: true }} labelId="subcat" value={taskData.task_subcat} onChange={(e)=> settaskData({...taskData, task_subcat: e.target.value})}>
                <MenuItem value={"Non-Refundable"}>Non-Refundable</MenuItem>
                <MenuItem value={"Refundable"}>Refundable</MenuItem>
               </Select>
                </FormControl>
                 <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="supplier">Supplier</InputLabel>
                <Select  displayEmpty required className={classes.textField} InputLabelProps={{ shrink: true }} labelId="subcat" value={taskData.supplier} onChange={(e)=> settaskData({...taskData, supplier: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                {supplierData.map((s) => {
                return <MenuItem value={s.supplier_name}>{s.supplier_name}</MenuItem>;
              })} 
               </Select>
                </FormControl>
                <TextField variant="outlined"  label="Amount (Number only)"   InputLabelProps={{ shrink: true }} value={taskData.amount} className={classes.textField}  onChange={(e)=> settaskData({...taskData, amount: e.target.value})}/>
                </div>
                ):("")}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="tickettype">Ticket Type</InputLabel>
                <Select  displayEmpty className={classes.textField} labelId="tickettype" value={taskData.ticket_category} onChange={(e)=> settaskData({...taskData, ticket_category: e.target.value})}>
                <MenuItem value={"L1"}>L1</MenuItem>;
                <MenuItem value={"L2"}>L2</MenuItem>;
                <MenuItem value={"L3"}>L3</MenuItem>;
                <MenuItem value={"L4"}>L4</MenuItem>;
           
                </Select>
                </FormControl>
            </FormGroup>
            

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default CreateTask;